import {
  cn,
  type CnParam,
} from '@repo/internal-tools-design-system/src/utils/cn.ts'
import type { StringWithAutoComplete } from '@repo/internal-tools-type-utils/src/utils.ts'
import type { ReactNode } from 'react'

const PREDEFINED_ERROR_MESSAGES = {
  ERROR: 'Something went wrong',
  '403': "You don't have permission to visit this page",
  '404': 'Page not found\nPlease check the URL and try again',
} satisfies Record<string, string>

type PredefinedErrorCode = keyof typeof PREDEFINED_ERROR_MESSAGES

const DEFAULT_ERROR_CODE = 'ERROR' as const satisfies PredefinedErrorCode

export type ErrorPageProps = {
  code?: StringWithAutoComplete<PredefinedErrorCode>
  description?: ReactNode
  className?: CnParam
}

export const ErrorPage = (props: ErrorPageProps) => {
  const {
    code = DEFAULT_ERROR_CODE,
    description = PREDEFINED_ERROR_MESSAGES[code as PredefinedErrorCode],
    className,
  } = props

  return (
    <div
      className={cn(
        'bg-background-primary grid min-h-dvh place-items-center',
        className,
      )}
    >
      <section className="space-y-space-y-sm p-space-card-comfort-standalone max-w-screen-w-sm text-center">
        <h1 className="typo-base-headings-h1 text-foreground-primary">
          {code}
        </h1>
        <p className="typo-base-text-sm text-foreground-secondary whitespace-pre-line">
          {description || PREDEFINED_ERROR_MESSAGES.ERROR}
        </p>
      </section>
    </div>
  )
}
